import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'
import GrupoUnidadMedidaGestion from './view/GrUniMed'

export const grupoUnidadMedidaRouteMap = {
  gestion: {
    path: '/grupounidadmedida/gestion',
    name: 'Grupo Unidad Medida',
  },
  registro: {
    path: '/grupounidadmedida/nuevo',
    name: 'Nuevo Grupo Unidad Medida',
  },
  actualizar: {
    path: '/grupounidadmedida/actualizar/:id',
    name: 'Actualizar Grupo Unidad Medida',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const grupoUnidadMedidaRoutes = [
  {
    path: grupoUnidadMedidaRouteMap.gestion.path,
    element: (
      <OperacionesProvider>
        <GrupoUnidadMedidaGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]
export default grupoUnidadMedidaRoutes
